import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaFileImage } from "react-icons/fa";

import ConstData from "../../lib/ConstData";

import Alerts from "../etc/list/Alerts";

const WebAddLocalServer = ({ isCheckSubDomainOK, selectedSubDomainInfo, list_localSite, list_localServerType, isAddLocalServerOK, resetEventId, alertMessage, alertKind, localServerAlertEventId, localServerAlertTarget, handleSelectedFunc, onChangeIsAddLocalServerOK }) => {
    const { t } = useTranslation();

    const [localServerName, setLocalServerName] = useState("");
    const [localServerType, setLocalServerType] = useState("UNKNOWN");

    const [lLocalSiteInfo, setLocalSiteInfo] = useState({ idx: 0, localSiteSeq: -1, localSiteName: "" });

    const [lAlertMessage, setAlertMessage] = useState("");
    const [lAlertKind, setAlertKind] = useState(ConstData.ALERT_KIND.NONE);

    useEffect(() => {
        // 20260814 신규 선택 가능한 타입 중 첫 항목을 기본값으로 사용한다.
        const firstType = (list_localServerType || []).find(info => info.useYn === "Y");
        if (firstType && !(list_localServerType || []).some(info => info.localServerType === localServerType && info.useYn === "Y")) {
            setLocalServerType(firstType.localServerType);
        }
    }, [list_localServerType, localServerType]);

    useEffect(() => {
        if (localServerAlertTarget !== "CREATE" || alertKind === ConstData.ALERT_KIND.NONE) {
            setAlertKind(ConstData.ALERT_KIND.NONE);
            setAlertMessage("");
            return;
        }
        // 20260814 등록 결과만 등록 패널 안에서 같은 문구도 매번 다시 표시한다.
        setAlertKind(alertKind);
        setAlertMessage(alertMessage);
        const timer = setTimeout(() => {
            setAlertKind(ConstData.ALERT_KIND.NONE);
            setAlertMessage("");
        }, 2500);
        return () => clearTimeout(timer);
    }, [localServerAlertEventId, localServerAlertTarget, alertKind, alertMessage]);

    useEffect(() => {
        if (list_localSite && list_localSite.length > 0) {
            setLocalSiteInfo({ idx: 0, localSiteSeq: list_localSite[0].localSiteSeq, localSiteName: list_localSite[0].localSiteName });
        }
    }, [list_localSite]);

    useEffect(() => {
        if (isAddLocalServerOK) {
            setLocalServerName("");
            setLocalServerType(((list_localServerType || []).find(info => info.useYn === "Y") || {}).localServerType || "UNKNOWN");
            onChangeIsAddLocalServerOK();

            if (list_localSite && list_localSite.length > 0) {
                setLocalSiteInfo({ idx: 0, localSiteSeq: list_localSite[0].localSiteSeq, localSiteName: list_localSite[0].localSiteName });
            } else {
                setLocalSiteInfo({ idx: 0, localSiteSeq: -1, localSiteName: "" });
            }
        }
    }, [isAddLocalServerOK]);

    useEffect(() => {
        if (!resetEventId) return;

        // 20260813 등록 패널 닫힘 완료 후 미저장 입력값과 알림을 초기화한다.
        setLocalServerName("");
        setLocalServerType(((list_localServerType || []).find(info => info.useYn === "Y") || {}).localServerType || "UNKNOWN");
        setAlertMessage("");
        setAlertKind(ConstData.ALERT_KIND.NONE);

        if (list_localSite && list_localSite.length > 0) {
            setLocalSiteInfo({ idx: 0, localSiteSeq: list_localSite[0].localSiteSeq, localSiteName: list_localSite[0].localSiteName });
        } else {
            setLocalSiteInfo({ idx: 0, localSiteSeq: -1, localSiteName: "" });
        }
    }, [resetEventId]);

    const onChangeLocalServerName = (e) => {
        setLocalServerName(e.target.value);
    }

    const onChangeSelectLocalSite = (e) => {
        if (list_localSite && list_localSite.length > 0) {
            let idx = e.target.value;
            setLocalSiteInfo({ idx, localSiteSeq: list_localSite[idx].localSiteSeq, localSiteName: list_localSite[idx].localSiteName });
        }
    }

    const onClickAddLocalServer = (e) => {
        handleSelectedFunc({ selectedFunc: "CREATE_LOCAL_SERVER", data: { serverName: localServerName, subDomainSeq: selectedSubDomainInfo.subDomainSeq, localSiteSeq: lLocalSiteInfo.localSiteSeq, localSiteName: lLocalSiteInfo.localSiteName, localServerType } });
    }

    return (
        <div className="d-flex py-3 align-items-center justify-content-center border-bottom">
            <div className="card web-list-card border-primary">
                <div className="input-area">
                    <div className="input-label font-md">
                        <span><b>{t("로컬_서버_타입", { ns: "admin" })}</b></span>
                    </div>
                    <div className="input-data">
                        <select className="custom-select small my-1" style={{ width: '100%', fontSize: '0.9rem' }} value={localServerType} onChange={(e) => setLocalServerType(e.target.value)}>
                            {(list_localServerType || []).filter(info => info.useYn === "Y").map(info => <option value={info.localServerType} key={info.localServerType}>{t(`서버_타입_${info.localServerType}`, { ns: "admin", defaultValue: info.localServerTypeName })}</option>)}
                        </select>
                    </div>
                </div>
                <div className="input-area">
                    <div className="input-label font-md">
                        <span><b>{t("로컬_서버_이름", { ns: "admin" })}</b></span>
                    </div>
                    <div className="input-data">
                        <div className="d-flex input-group justify-content">
                            <input type="email" id="inputLocalServerName" value={localServerName} className="d-flex flex-fill web-search-input mr-2" placeholder={t("로컬_서버_이름_입력", { ns: "admin" })} style={{ width: '70%' }} onChange={onChangeLocalServerName} />
                        </div>
                    </div>
                </div>
                <div className="input-area">
                    <div className="input-label font-md">
                        <span><b>{t("로컬_사이트", { ns: "admin" })}</b></span>
                    </div>
                    <div className="input-data">
                        <select className="custom-select small my-1" style={{ width: '100%', fontSize: '0.9rem' }} value={lLocalSiteInfo.idx} onChange={onChangeSelectLocalSite}>
                            {
                                list_localSite && list_localSite.length > 0 ?
                                    list_localSite.map((info, index) => (
                                        <option value={index} key={"itemOption-" + index}>{info.localSiteName}</option>
                                    )) :
                                    <option value={-1}>
                                        {t("선택_가능한_로컬_사이트_없음", { ns: "admin" })}
                                    </option>
                            }
                        </select>
                    </div>
                </div>
                <Alerts kind={lAlertKind} message={lAlertMessage} />
                <div className="d-flex text-center mt-3">
                    <button type="button" className="btn btn-md hiclasstv-blue white-text m-0 px-4 py-1" onClick={onClickAddLocalServer} disabled={localServerName !== "" ? false : true}>
                        <b>{t("생성", { ns: "common" })}</b>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WebAddLocalServer;
